import { useQueryClient } from "@tanstack/react-query";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { Suspense } from "react";
import useFlowBack from "@/hooks/@common/useFlowBack";
import GuestbookDetailPage from "@/pages/guestbookDetail/GuestbookDetailPage";

export const Route = createFileRoute(
  "/_appOnly/_authenticated/spaces/$spaceId/guestbook/$guestbookId",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { spaceId, guestbookId } = Route.useParams();
  const navigate = useNavigate();
  const flowBack = useFlowBack();
  const queryClient = useQueryClient();

  const invalidateGuestbookQueries = () => {
    queryClient.invalidateQueries({
      queryKey: ["guestbook", spaceId, "list"],
    });
  };

  return (
    <Suspense fallback={null}>
      <GuestbookDetailPage
        spaceId={spaceId}
        currentId={Number(guestbookId)}
        onBack={() => {
          invalidateGuestbookQueries();
          flowBack({ to: "/spaces/$spaceId/guestbook", params: { spaceId } });
        }}
        onNavigate={(id) =>
          navigate({
            to: "/spaces/$spaceId/guestbook/$guestbookId",
            params: { spaceId, guestbookId: String(id) },
            replace: true,
          })
        }
        onDeleteSuccess={() => {
          invalidateGuestbookQueries();
          flowBack({ to: "/spaces/$spaceId/guestbook", params: { spaceId } });
        }}
      />
    </Suspense>
  );
}
